import Assert from '../utils/Assert';
// import MetroCode from './MetroCode';

export default class Ems {
  constructor(metroCode, emsAll, privateBackup, privateCloud, firewall, domesticSolutions, privateNvidiaAI) {
    // Assert.instanceOf(metroCode, MetroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);
    Assert.isString(metroCode);

    this.metroCode = metroCode;
    this.emsAll = emsAll;
    this.privateBackup = privateBackup;
    this.privateCloud = privateCloud;
    this.firewall = firewall;
    this.domesticSolutions = domesticSolutions;
    this.privateNvidiaAI = privateNvidiaAI;
    Object.freeze(this);
  }

  equals(other) {
    if (!(other instanceof Ems)) {
      return false;
    }

    // return this.metroCode.equals(other.metroCode);
    return this.metroCode === other.metroCode;
  }

  toString() {
    return `${this.constructor.name}{ metroCode:'${this.metroCode}', emsAll:${this.emsAll}, privateBackup:${this.privateBackup}, privateCloud:${this.privateCloud}, firewall:${this.firewall}, domesticSolutions:${this.domesticSolutions}, privateNvidiaAI:${this.privateNvidiaAI}}`;
  }

  toJSON() {
    const { metroCode, emsAll, privateBackup, privateCloud, firewall, domesticSolutions, privateNvidiaAI } = this;
    return { metroCode, emsAll, privateBackup, privateCloud, firewall, domesticSolutions, privateNvidiaAI };
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    const { metroCode, emsAll, privateBackup, privateCloud, firewall, domesticSolutions, privateNvidiaAI } = json;

    return new Ems(metroCode, emsAll, privateBackup, privateCloud, firewall, domesticSolutions, privateNvidiaAI);
  }

  static fromJSONArray(jsonArray) {
    if (!jsonArray) {
      return [];
    }

    const items = [];
    for (const json of jsonArray) {
      const p = Ems.fromJSON(json);
      items.push(p);
    }

    return items;
  }
}
